import { useQuery } from '@apollo/client';
import { graphql } from '../gql';
import { useMemo } from 'react';
import { RegionFilterInput } from '../gql/graphql';

const GET_REGIONS = graphql(`
  query getRegions(
    $filters: RegionFilterInput
    $pagination: PaginationRequest
    $sort: PaginationSort
  ) {
    regions(filters: $filters, pagination: $pagination, sort: $sort) {
      pageInfo {
        totalResults
        hasNextPage
        hasPreviousPage
        pageNumber
        pageSize
      }
      edges {
        node {
          uuid
          name
          type
          iso2Code
          createdAt
          updatedAt
        }
      }
    }
  }
`);

export function useGetRegionsQuery(regionFilter: RegionFilterInput) {
  const { loading, error, data } = useQuery(GET_REGIONS, {
    variables: {
      pagination: { after: 0, first: 5100 },
      sort: { key: 'name', order: 'ASC' },
      filters: regionFilter,
    },
  });

  const { regions } = useMemo(() => {
    return {
      regions: data?.regions.edges.map((edge) => edge.node) ?? [],
    };
  }, [data]);

  return {
    loading,
    error,
    data,
    regions,
  };
}
